<template>
  <div class="steps" style="max-width: 400px">
    <h1>{{ resource["resetPassword.PasswordSecurityTipsText"] }}</h1>
    <ul>
      <li>
        <b>{{ resource["resetPassword.DifferentPasswordText"] }}</b>
        <div class="description">
          {{ resource["resetPassword.TryYourPasswordText"] }}
        </div>
      </li>
      <li>
        <b>{{ resource["resetPassword.AboutYourselfText"] }} </b>
        <div class="description">
          {{ resource["resetPassword.SomeoneWhoKnowsYouText"] }}
        </div>
      </li>
      <li>
        <b>{{ resource["resetPassword.HardPasswordText"] }} </b>
        <div class="description">
          {{ resource["resetPassword.RandomCharacterText"] }}
        </div>
      </li>
      <li>
        <b>{{ resource["resetPassword.OftenChangePasswordText"] }} </b>
        <div class="description">
          {{ resource["resetPassword.UpdateYourPasswordText"] }}
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'SecurePasswordSteps',
};
</script>
<style scoped lang="scss">
.steps {
  position: relative;
  text-align: left;
  max-width: 400px;

  h1 {
    margin-top: 62px;
    padding-bottom: 10px;
    color: #4C4C4C;
    border-bottom: 1px solid white;
  }
  ul {
    padding-left: 15px;
    color: #4C4C4C;
    li {
      list-style: none;
      font-size: 15px;
      margin-top: 15px;
      .description {
        opacity: 0.8;
      }
      &::before {
        content: "●";
        position: absolute;
        border-radius: 50%;
        margin-top: -1px;
        left: -2px; /* Adjust this value so that it appears where you want. */
        font-size: 1.1em;
      }
    }
  }
}
</style>
